<template>
    <v-col cols="12">
        <v-input
            :rules="rules"
            :value="items.length"
            class="secret-input"
            ref="input"
        />
        <DataTableToolbar
            :alert="alert"
            :item="item"
            :readonly="disableInsert || readonly"
            :records="items"
            v-on:newItem="newItem"
        />
        <v-expansion-panels 
            popout
            v-model="editedIndex"
        >
            <v-expansion-panel 
                v-for="(thisItem, index) in items"
                v-bind:key="'expansionPanel-' + index"
            >
                <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                        <v-container>
                            <v-row no-gutters justify="space-between" :class="open ? 'open-header-bdcolor' : ''">
                                <v-col  
                                    v-for="(thisValue, headerIndex) in computedHeaders"
                                    v-bind:key="'ExpansionPanel-' + index + 'Header-' + headerIndex"
                                    :cols="computedHeaders.length >= 5 ? 2 : 3"
                                    :class="`${headerIndex == 0 ? 'text-start' : 'text-end'} pr-6`"
                                >
                                    <span class="text-lg-subtitle-1">{{ thisValue.text }}</span><br />
                                    <span class="text-lg-caption">{{ thisItem[thisValue.value] }}</span>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <ItemForm
                        :structureData="structureData"
                        :projectId="projectId"
                        :moduleKey="moduleKey"
                        :userId="userId"
                        exitLabel="Delete"
                        v-bind:key="Date.now()"
                        v-model="items[index]"
                        v-on:cancel="handleCancel"
                        v-on:confirm="handleConfirm"
                        v-on:exit="handleExit"
                        :handleTabChange="handleTabChange"
                        :openQuestionnaire="openQuestionnaire"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-col>
</template>

<script>
    import DataTableToolbar from './data-table-toolbar.vue'
    import { rules } from '../utilities'
    import dataTableMixins from './mixins/data-table-mixins'

    export default {
        mixins: [dataTableMixins],
        name: 'ExpandableTable',
        props: {
            alert: String,
            item: Object,
            questionWidth: String,
            readonly: Boolean,
            rules: Array,
            value: Array,
            optional: Boolean,
            projectId: String,
            moduleKey: String,
            userId: String,
            handleTabChange: Function,
            openQuestionnaire: Function
        },
        components: {
            ItemForm: () => import("./item-form"),
            DataTableToolbar
        },
        data: function () {
            return {
                isNewItem: false
            }
        },
        mounted: function () {
            this.setStructure();
        },
        methods: {
            handleCancel () {
                if (this.isNewItem) {
                    this.deleteItem(this.items[this.editedIndex], true);
                    this.editedIndex = null;
                } else {
                    this.close();
                }

                this.isNewItem = false;
            },
            handleConfirm (modelData) {
                this.isNewItem = false;
                this.save(modelData);
            },
            handleExit () {
                this.deleteItem(this.items[this.editedIndex], true);
                this.editedIndex = null;
                this.isNewItem = false;
            },
            newItem: function () {
                this.$emit('input', [{}].concat(this.items));
                this.editedIndex = 0;
                this.isNewItem = true;
            }
        }
    }
</script>

<style scoped>
    /* The input is used for tracking items, but should not be visible */
    .secret-input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .v-list-item {
        display: inline-flex !important;
    }

    .open-header-bdcolor { 
        padding-bottom: 1.5rem;
        border-bottom: 1px dashed #cceaed !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/expandable-table.vue